$(() => {
  const fte_managing_compliance_docs = () => {
    const net_patient_revenue = parseInt($('#net-patient-revenue').val().replaceAll(',', ''), 10);

    if (net_patient_revenue <= 50000000) {
      return 3;
    } else if (net_patient_revenue <= 1000000000) {
      return 6;
    } else if (net_patient_revenue <= 3000000000) {
      return 8;
    }

    return 20;
  };

  const run = () => {
    if ($('#fte-managing-compliance-docs-overridden').val() === '0') {
      $('#fte-managing-compliance-docs').val(fte_managing_compliance_docs());
    }
  };

  run();

  $('#net-patient-revenue').blur(() => {
    run();
  });

  $('#fte-managing-compliance-docs').blur(() => {
    $('#fte-managing-compliance-docs-overridden').val('1');
  });
});
